import { Route } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { ADMIN_ROUTES } from "@/shared/constants/paths";

// Admin Pages
import LawyersPage from "@/pages/admin/lawyers/LawyersPage";
import LawyerDetailPage from "@/pages/admin/lawyer-detail/LawyerDetailPage";
import PixelContentPage from "@/pages/admin/pixel-content/PixelContentPage";
import FeatureFlagsPage from "@/pages/admin/feature-flags/FeatureFlagsPage";

import { styleGuideRoutes } from "./StyleGuideRoutes";

export const adminRoutes = (
  <>
    <Route
      path={ADMIN_ROUTES.LAWYERS}
      element={
        <>
          <Helmet>
            <title>Lawyers - Elayne Admin</title>
          </Helmet>
          <LawyersPage />
        </>
      }
    />
    <Route
      path={ADMIN_ROUTES.LAWYER_DETAIL}
      element={
        <>
          <Helmet>
            <title>Lawyer Detail - Elayne Admin</title>
          </Helmet>
          <LawyerDetailPage />
        </>
      }
    />
    <Route
      path={ADMIN_ROUTES.PIXEL_CONTENT}
      element={
        <>
          <Helmet>
            <title>Pixel Email Content - Elayne Admin</title>
          </Helmet>
          <PixelContentPage />
        </>
      }
    />
    <Route
      path={ADMIN_ROUTES.FEATURE_FLAGS}
      element={
        <>
          <Helmet>
            <title>Feature Flags - Elayne Admin</title>
          </Helmet>
          <FeatureFlagsPage />
        </>
      }
    />
    {styleGuideRoutes}
  </>
);
